import React from 'react';
import {injectIntl} from 'react-intl';
import Icon from '@Components/Icon';

const SelectField = ({intl, settings, ...rest}) => {
  const {
    label,
    noIntl = false,
    required = true,
    state,
    hidden = false,
    skipOnEmpty = false,
    errors,
    disabled = false,
    description = false,
  } = settings || {};
  const {options} = settings || [];
  let {name} = settings || {};
  if (rest.hasOwnProperty('name')) {
    name = rest.name;
  }

  if (skipOnEmpty) {
    rest['data-skip-empty-field'] = true;
  }

  const hasErrors = (errors && ((errors.hasOwnProperty(name) && errors[name].length) || errors.hasOwnProperty('generalError')));
  const id = `field--select--${name}`;

  const renderLabel = () => {
    if (!label) {
      return '';
    } else {
      return (
        <label className="form-group__label" htmlFor={id}>
          {noIntl ? label : intl.formatMessage({id: label})}
          {!required &&
          <span className="form-group__optional"> {intl.formatMessage({id: 'FormElements.Label.Optional'})}</span>}
        </label>
      );
    }
  };

  const renderOptions = () => {
    if (options) {
      return options.map((option, index) => {
        return (
          <option value={option.value} key={`select-${name}-option-${index}`}>
            {option.isTranslation ? intl.formatMessage({id: option.label}) : option.label}
          </option>
        );
      });
    }
    return '';
  };

  const renderErrors = () => {
    if (hasErrors && errors.hasOwnProperty(name) && errors[name].length) {
      return (
        <div key={`errorField-${name}`} className="form-group__feedback">{errors[name]}</div>
      );
    }
    return '';
  };

  if (hidden) {
    return '';
  }

  const renderDescription = () => {
    if (description) {
      return (
        <div className="form-group__message">{noIntl ? description : intl.formatMessage({id: description})}</div>
      );
    }

    return '';
  };

  return (
    <div className={`form-group ${hasErrors ? 'form-group--error' : ''}`}>
      {renderLabel()}
      <div className="form-group__input">
        <select
          id={id}
          name={name}
          required={required}
          data-rs-untouched=""
          value={(state && state.hasOwnProperty(name) ? state[name] : '')}
          disabled={disabled}
          {...rest}
        >
          {renderOptions()}
        </select>
        <span className="select-arrow icon">
          <Icon type='chevron-down'/>
        </span>
      </div>
      {renderDescription()}
      {renderErrors()}
    </div>
  );
};

export default injectIntl(SelectField);
